export default {
    searchText: 'ค้นหาโดย สำนักงาน / องค์กร',
    search: 'ค้นหา',
    orgId: 'รหัสสำนักงาน',
    bureau: 'สำนักงาน',
    bureauAcronym: 'ตัวย่อ สำนักงาน',
    parentId: 'รหัสสายงาน',
    organization: 'องค์กร',
    totalEmployee: 'พนักงานทั้งหมด'
}
